import _ from 'underscore';
import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { FAQSection } from '@bingads-webui-campaign-react/faq-accordion';
import { useIntersectionObserver } from '@bingads-webui-campaign-react/pmax-landing-utils';
import { Constants } from '@bingads-webui-theme-2018/theme-fluent';
import { useResponsiveSize } from '@adscore/with-responsive-size';

import { FAQArray } from './constants';
import { getLandingPageFAQStyles } from './landing-page-faq-styles';

export function LandingPageFAQ(props) {
  const {
    logger,
  } = props;
  const classes = useDefaultStyles(getLandingPageFAQStyles);
  const displayMode = useResponsiveSize(Constants.ResponsiveSizeBreakpoints);
  const ref = useRef();

  const onScrollToView = useCallback(() => {
    logger.trace('LandingPageFAQ scrolled into view');
  }, [logger]);

  useIntersectionObserver({
    ref,
    onScrollToView,
  });

  return (
    <div
      ref={ref}
      className={classNames('landing-page-faq', classes.container, classes[`container-${displayMode}`])}
      role="region"
    >
      <FAQSection
        logger={logger}
        faqArray={FAQArray}
      />
    </div>
  );
}

LandingPageFAQ.propTypes = {
  logger: PropTypes.shape({
    trace: PropTypes.func.isRequired,
  }),
};

LandingPageFAQ.defaultProps = {
  logger: {
    trace: _.noop,
  },
};
